import { MEETING_LINK_DEVICE_TOKEN_KEY_PREFIX } from './constants';

const createDeviceToken = (): string => {
  if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
    return crypto.randomUUID();
  }

  return 'xxxxxxxx-xxxx-4xxx-yxxx-xxxxxxxxxxxx'.replace(/[xy]/g, (char) => {
    const random = Math.random() * 16 | 0;
    const value = char === 'x' ? random : ((random & 0x3) | 0x8);
    return value.toString(16);
  });
};

const ephemeralDeviceTokens = new Map<string, string>();

export const getMeetingLinkDeviceTokenStorageKey = (meetingLinkPath: string): string => {
  return `${MEETING_LINK_DEVICE_TOKEN_KEY_PREFIX}${meetingLinkPath}`;
};

export const resetMeetingLinkDeviceTokenCache = (): void => {
  ephemeralDeviceTokens.clear();
};

export const getOrCreateMeetingLinkDeviceToken = (meetingLinkPath: string): string => {
  const storageKey = getMeetingLinkDeviceTokenStorageKey(meetingLinkPath);

  try {
    const existingToken = window.localStorage.getItem(storageKey);
    if (existingToken) {
      ephemeralDeviceTokens.set(meetingLinkPath, existingToken);
      return existingToken;
    }

    const deviceToken = createDeviceToken();
    window.localStorage.setItem(storageKey, deviceToken);
    ephemeralDeviceTokens.set(meetingLinkPath, deviceToken);
    return deviceToken;
  } catch {
    const cachedToken = ephemeralDeviceTokens.get(meetingLinkPath);
    if (cachedToken) {
      return cachedToken;
    }

    const deviceToken = createDeviceToken();
    ephemeralDeviceTokens.set(meetingLinkPath, deviceToken);
    return deviceToken;
  }
};
